import "./App.css";
import LayoutWrapper from "./components/LayoutWrapper";
import SimuladorCredito from "./components/SimuladorCredito";
import { NotificationProvider } from "./components/NotificationContext";

function App() {
  return (
    <NotificationProvider>
      <LayoutWrapper>
        <SimuladorCredito />
      </LayoutWrapper>
    </NotificationProvider>
  );
}

export default App;
